import classNames from "classnames";

function ListGroup({ items, renderItem, className = "mb-0" }) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={classNames("list-group", className)}>
      {items.map((item, index) => (
        <div key={index} className="list-group-item">
          {renderItem ? renderItem(item) : String(item)}
        </div>
      ))}
    </div>
  );
}

export default ListGroup;
